(function () {
  function getLang() {
    const path = window.location.pathname;
    if (path.startsWith('/es')) return 'es';
    if (path.startsWith('/de')) return 'de';
    return 'en';
  }

  const lang = getLang();
  if (lang === 'en') return;

  const translations = {
    es: {
      exact: {
        "Start date": "Fecha de inicio",
        "Days (1-90)": "Días (1-90)",
        "Plan type": "Tipo de plan",
        "Email to receive your eSIM (QR code)": "Email para recibir tu eSIM (código QR)",
        "Check device compatibility": "Comprobar compatibilidad",
        "Add to cart": "Agregar al carrito",
        "Data only (Unlimited)": "Solo datos (Ilimitado)",
        "Calls only": "Solo llamadas",
        "Data + Calls": "Datos + Llamadas",
        "More payment options": "Más opciones de pago",
        "Select a date": "Selecciona una fecha"
      },
      words: {
        "From": "Desde",
        "to": "hasta",
        "day": "día",
        "days": "días",
        "January": "enero",
        "February": "febrero",
        "March": "marzo",
        "April": "abril",
        "May": "mayo",
        "June": "junio",
        "July": "julio",
        "August": "agosto",
        "September": "septiembre",
        "October": "octubre",
        "November": "noviembre",
        "December": "diciembre"
      }
    },
    de: {
      exact: {
        "Start date": "Startdatum",
        "Days (1-90)": "Tage (1-90)",
        "Plan type": "Plantyp",
        "Email to receive your eSIM (QR code)": "E-Mail zum Erhalt deiner eSIM (QR-Code)",
        "Check device compatibility": "Gerätekompatibilität prüfen",
        "Add to cart": "In den Warenkorb",
        "Data only (Unlimited)": "Nur Daten (Unbegrenzt)",
        "Calls only": "Nur Anrufe",
        "Data + Calls": "Daten + Anrufe",
        "More payment options": "Weitere Zahlungsoptionen",
        "Select a date": "Datum auswählen"
      },
      words: {
        "From": "Von",
        "to": "bis",
        "day": "Tag",
        "days": "Tage",
        "January": "Januar",
        "February": "Februar",
        "March": "März",
        "April": "April",
        "May": "Mai",
        "June": "Juni",
        "July": "Juli",
        "August": "August",
        "September": "September",
        "October": "Oktober",
        "November": "November",
        "December": "Dezember"
      }
    }
  };

  const map = translations[lang];

  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function replaceExactText(text) {
    const trimmed = text.trim();
    if (!trimmed) return text;

    if (map.exact[trimmed]) {
      return text.replace(trimmed, map.exact[trimmed]);
    }

    return text;
  }

  function replaceDynamicWords(text) {
    let result = text;

    Object.entries(map.words).forEach(([from, to]) => {
      const regex = new RegExp(`\\b${escapeRegExp(from)}\\b`, 'g');
      result = result.replace(regex, to);
    });

    return result;
  }

  function translateText(text) {
    let result = text;
    result = replaceExactText(result);
    result = replaceDynamicWords(result);
    return result;
  }

  function replaceTextNode(node) {
    if (!node || !node.nodeValue) return;

    const original = node.nodeValue;
    const translated = translateText(original);

    if (translated !== original) {
      node.nodeValue = translated;
    }
  }

  function translateElementAttributes(root) {
    if (!root || root.nodeType !== 1) return;

    const attrList = ['placeholder', 'value', 'title', 'aria-label'];

    attrList.forEach(attr => {
      if (root.hasAttribute && root.hasAttribute(attr)) {
        const original = root.getAttribute(attr);
        if (original) {
          const translated = translateText(original);
          if (translated !== original) {
            root.setAttribute(attr, translated);
          }
        }
      }
    });
  }

  function walk(node) {
    if (!node) return;

    if (node.nodeType === Node.TEXT_NODE) {
      replaceTextNode(node);
      return;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) return;

    translateElementAttributes(node);

    for (const child of node.childNodes) {
      walk(child);
    }
  }

  function translateDOM(root = document.body) {
    walk(root);
  }

  function run() {
    translateDOM(document.body);
  }

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 || node.nodeType === 3) {
          translateDOM(node);
        }
      });
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();